import { User, Users, Check } from "lucide-react";
import { Reveal } from "@/components/site/Reveal";
import { Billet } from "@/components/site/Billet";
import { useLang } from "@/context/LanguageContext";

export default function Offer() {
  const { t } = useLang();
  const st = t.soloTeam;
  const inc = t.included;

  return (
    <>
      {/* 8. Seul ou en team */}
      <section className="bg-[#F6F1E8] py-24 sm:py-32" data-testid="section-solo-team">
        <div className="mx-auto max-w-7xl px-5">
          <div className="mb-14 max-w-2xl">
            <span className="font-marker text-lg text-[#3F9BA6]">{st.kicker}</span>
            <Reveal>
              <h2 className="mt-2 font-display text-4xl leading-[0.95] text-[#14283A] sm:text-6xl">
                {st.titlePre} <span className="grad-underline">{st.titleAccent}</span>
              </h2>
            </Reveal>
          </div>
          <div className="grid grid-cols-1 gap-6 md:grid-cols-2">
            <Reveal>
              <div className="h-full rounded-2xl border-2 border-[#14283A] bg-white p-8 shadow-[6px_6px_0_0_#14283A]">
                <User className="h-9 w-9 text-[#EA7A4F]" />
                <h3 className="mt-4 font-display text-2xl text-[#14283A]">{st.soloTitle}</h3>
                <p className="mt-3 text-[#14283A]/75">{st.soloBody}</p>
              </div>
            </Reveal>
            <Reveal delay={0.1}>
              <div className="h-full rounded-2xl border-2 border-[#14283A] bg-[#14283A] p-8 text-[#F6F1E8] shadow-[6px_6px_0_0_#EA7A4F]">
                <Users className="h-9 w-9 text-[#EA7A4F]" />
                <h3 className="mt-4 font-display text-2xl">{st.teamTitle}</h3>
                <p className="mt-3 text-[#F6F1E8]/80">{st.teamBody}</p>
              </div>
            </Reveal>
          </div>
        </div>
      </section>

      {/* 9. Ce qui est inclus */}
      <section id="inclus" className="bg-[#F6F1E8] py-24 sm:py-32" data-testid="section-inclus">
        <div className="mx-auto max-w-5xl px-5">
          <div className="mb-12 text-center">
            <span className="font-marker text-lg text-[#3F9BA6]">{inc.kicker}</span>
            <Reveal>
              <h2 className="mt-2 font-display text-4xl text-[#14283A] sm:text-6xl">{inc.title}</h2>
            </Reveal>
          </div>
          <Reveal>
            <Billet notchColor="#F6F1E8" stamp>
              <div className="p-8 sm:p-10">
                <div className="mb-6 flex items-center justify-between gap-2">
                  <span className="font-display text-base tracking-tight text-[#14283A] sm:text-lg">
                    {inc.passLabel}
                  </span>
                  <span className="font-marker text-[#EA7A4F]">{inc.passTag}</span>
                </div>
                <div className="border-t-2 border-dashed border-[#14283A]/20 pt-6">
                  <div className="grid grid-cols-1 gap-5 sm:grid-cols-2">
                    {inc.items.map(([tt, d]) => (
                      <div key={tt} className="flex gap-3">
                        <span className="grad-bar mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full text-white">
                          <Check className="h-3.5 w-3.5" strokeWidth={3} />
                        </span>
                        <div>
                          <div className="font-bold text-[#14283A]">{tt}</div>
                          <div className="text-sm text-[#14283A]/65">{d}</div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </Billet>
          </Reveal>
        </div>
      </section>
    </>
  );
}
